module.exports = __webpack_public_path__ + "media/images/trip_default_logo_db-541108d1a01b8f4e4fe8f04e508283be.jpg";